import { makeStyles } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../Utils/_helpers";
import {
  Card,
  CardBody,
  CardFooter,
} from "../../../../../../Utils/_partials/controls";
import { useMobileViewport } from "../../../../../util/mobileViewPort";
import SoundActionsPopover from "./QuickActions/SoundActionsPopover";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Overlay,Tooltip } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
  card: {
    border: "1px solid #dee0e2 !important",
    background: "#f3f6f9",
    marginBottom: 0,
  },

  cardHeader: {
    background: "#093C !important",
    [theme.breakpoints.down("md")]: {},
  },

  cardBody: {
    background: "#fff",
    minHeight: "181px",
    [theme.breakpoints.down("md")]: {},
  },

  cardFooter: {
    backgroundColor: "#f3f6f9 !important",
    borderTop: "1px solid #dee0e2",
    overflow: "auto",
    maxHeight: "140px",
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up("lg")]: {
      height: 140,
    },

    [theme.breakpoints.down("md")]: {
      padding: (toggleDesc) => !toggleDesc && theme.spacing(0),
    },
  },

  expandHide: {
    backgroundColor: "#f3f6f9 !important",
    color: "#2d3689",
    fontSize: "12px",
    fontWeight: 600,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    paddingBottom: theme.spacing(1),
  },

  title: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#2c2c2c",
  },
  activeCard: {
    borderColor: "#2d3689 !important",
  },
  activeSoundCardBg: {
    background: "#2d3689",
  },
  activeSoundCardColor: {
    color: "#fff !important",
  },
}));
var selectedSounds = [];
const SoundsCard = ({
  sound,
  id,
  children,
  handleCheckedSounds,
  soundFilesPausedDuration,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openActionsPopover, setopenActionsPopover] = useState(false);
  const [toggleDesc, setToggleDesc] = useState(false);

  const { soundlibobj } = sound;
  const { status } = soundlibobj;

  const classes = useStyles(toggleDesc);

  const selectedSoundList = useSelector(
    (state) => state.soundsSlice.selectedSounds
  );

  useEffect(() => {
    if (selectedSoundList.length === 0) {
      selectedSounds = [];
    }
  }, [selectedSoundList]);

  var isSoundFilePlaying = false;
  React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return child;
    }

    if (child.props && child.props.children) {
      isSoundFilePlaying = child.props.children.props.sound.playing;
    }
  });

  const handleSoundActionsOnClick = (event) => {
    setAnchorEl(event.currentTarget);
    setopenActionsPopover(true);
  };

  const closeSoundActionsPopover = () => {
    setopenActionsPopover(false);
    setAnchorEl(null);
  };
  function ClipWithTip(props) {
    const [show, _setShow] = useState(false);
    const target = useRef(null);

    const setShow = (v) => {
      _setShow(v);
      if (v) {
        setTimeout(() => {
          _setShow(false);
        }, 1000);
      }
    };

    return (
      <>
        <CopyToClipboard
          text={props.text}
          onCopy={() => {
            setShow(true);
          }}
        >
          <img
            alt=""
            ref={target}
            style={{ cursor: "pointer" }}
            onClick={() => setShow(!show)}
            className="copy-icn"
            src={toAbsoluteUrl("/media/sr/icons/crm/copy.svg")}
          />
        </CopyToClipboard>
        <Overlay target={target.current} show={show} placement="bottom">
          {(props) => (
            <Tooltip
              id="overlay-example"
              className="queuemapping-history-dialog"
              {...props}
            >
              Copied to clipboard.
            </Tooltip>
          )}
        </Overlay>
      </>
    );
  }

  const handleOnChangeCheck = (event, selectedSound) => {
    const selectedValue = +event.target.value;
    if (!checkIsSoundSelected(selectedSounds)) {
      selectedSounds.push(selectedSound);
    } else {
      selectedSounds = selectedSounds.filter(
        (sound) => sound?.id !== selectedValue
      );
    }
    handleCheckedSounds(selectedSounds);
  };

  const handleDescToggle = () => {
    setToggleDesc((prev) => !prev);
  };

  const soundStatus = (status) => {
    const statuses = {
      0: {
        label: "Under Review",
        background: "orange",
      },
      1: {
        label: "Active",
        background: "green",
      },
      2: {
        label: "Rejected",
        background: "red",
      },
      3: {
        label: "Default",
        background: "white",
      }
    };
    return statuses[status];
  };

  let pausedSound = soundFilesPausedDuration.find(
    (file) => file.currentDuration > 0
  );
  const checkIsSoundSelected = (soundsList) =>
    soundsList.some((soundObj) => soundObj?.id === sound?.id);

  return (
    <div className="col-12 col-lg-3 mb-8" key={id}>
      <Card
        className={` ${classes.card} custom-card-style h-100 check ${
          isSoundFilePlaying || (pausedSound && pausedSound.id === id)
            ? classes.activeCard 
            : ""
        }`}
      >
        <CardBody
          className={`px-2 py-3 flex-grow-0 ${
            isSoundFilePlaying || (pausedSound && pausedSound.id === id) ? classes.activeSoundCardBg : ""
          }  ${classes.cardBody}`}
        >
          <div className="d-flex flex-column flex-grow-1">
            <div className="d-flex flex-grow-1 justify-content-between mr-2 mb-2">
              <div
                className={`d-flex  align-items-center sound-card-header ${(isSoundFilePlaying || (pausedSound && pausedSound.id === id) ) &&
                  "sound-card-active"}`}
              >
                <Checkbox
                  style={{ width: "16px", height: "16px" }}
                  color="primary"
                  value={sound?.id}
                  checked={checkIsSoundSelected(selectedSoundList)}
                  disabled={
                    selectedSoundList.length > 9 &&
                    !checkIsSoundSelected(selectedSoundList)
                  }
                  onChange={(event) => {
                    handleOnChangeCheck(event, sound);
                  }}
                  className="mr-4 ml-3"
                />
                <span
                  className={`${classes.title} ${(isSoundFilePlaying || (pausedSound && pausedSound.id === id) )&&
                    classes.activeSoundCardColor}`}
                >
                  {soundlibobj.soundname}
                </span>
              </div>
              <div className="d-flex">
                <img
                  style={{ cursor: "pointer" }}
                  alt="more"
                  onClick={(e) => {
                    handleSoundActionsOnClick(e);
                  }}
                  src={`${toAbsoluteUrl(
                    `/media/sr/icons/more-icon-inactive.svg`
                  )}`}
                />
              </div>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <div className="mb-3" style={{ minHeight: "53px" }}>
                {children}
              </div>

              <div>
                <span
                  className={`${(isSoundFilePlaying || (pausedSound && pausedSound.id === id)) &&
                    classes.activeSoundCardColor}`}
                >
                  <strong>
                    {sound?.type === "TTS" ? "Text-to-speech" : ""}
                  </strong>
                </span>
              </div>
              <div className="d-flex w-100 ml-2">
                <div className="d-flex w-25 mt-4 ml-4 align-items-center">
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      background: `${soundStatus(+status).background}`,
                      borderRadius: "99px",
                      marginRight: "8px",
                      border: `${soundStatus(+status).label == 'Default' ? '.1px solid black' : 'none'}`
                    }}
                  ></span>
                  <span
                    style={{ color: "#616161", fontSize: "11px" }}
                    className={`${(isSoundFilePlaying || (pausedSound && pausedSound.id === id)) &&
                      classes.activeSoundCardColor}`}
                  >
                    {soundStatus(+status).label}
                  </span>
                </div>
                <div className="d-flex w-75 mt-4 mr-4 justify-content-end align-items-center">
                  <span
                    style={{ color: "#616161", fontSize: "12px", fontWeight:500 }}
                    className={`${(isSoundFilePlaying || (pausedSound && pausedSound.id === id)) &&
                      classes.activeSoundCardColor}`}
                  >
                    Sound ID 
                    
                  </span>
                  <span  className="d-flex ml-2 mr-1"
                          style={{
                            color: "#ff7800",
                            whiteSpace: "pre",
                          }}>{sound?.id}</span>
                  <ClipWithTip text={sound?.id} />
                </div>
              </div>
            </div>
          </div>
        </CardBody>
        <CardFooter className={`${classes.cardFooter}`}>
          {useMobileViewport()
            ? toggleDesc && soundlibobj.description
            : soundlibobj.description}
        </CardFooter>
        {useMobileViewport() && (
          <div
            className={`py-6 ${classes.expandHide}`}
            onClick={() => {
              handleDescToggle();
            }}
          >
            {toggleDesc ? "Hide" : "Expand"}
          </div>
        )}
      </Card>
      <SoundActionsPopover
        sound={sound}
        open={openActionsPopover}
        handleClosePopover={closeSoundActionsPopover}
        anchorEl={anchorEl}
      />
    </div>
  );
};

export default SoundsCard;
